import React, { useState } from 'react';
import { Dialog } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import { PageUtil } from '../../../utils/PageUtil';

export const AuthConfirmPage = () => {
  const handleClose = () => {
    setShow(false);
  };
  const parseURL = () => {
    const authpath = PageUtil.getParaValue('authpath');
    // const authpath = 'http%3A%2F%2Fleads.qq.com%3A9000%2Fpage%2Fauth%3FredirectUrl%3Dhttp%253A%252F%252Fa.b.com%26appId%3Dyingtao1%26outerAccountId%3D123%3D%26outerAccountName%3D%25E5%2590%258D%25E7%25A7%25B0abc%26thirdName%3D%E7%AC%AC%E4%B8%89%E6%96%B9%E5%BA%94%E7%94%A8#/';
    const afterDecode = decodeURIComponent(authpath);
    const redirectUrl = PageUtil.getParaValueFromUrl(afterDecode, 'redirectUrl');
    const appId = PageUtil.getParaValueFromUrl(afterDecode, 'appId');
    const thirdName = PageUtil.getParaValueFromUrl(afterDecode, 'thirdName');
    const outerAccountId = PageUtil.getParaValueFromUrl(afterDecode, 'outerAccountId');
    const outerAccountName = PageUtil.getParaValueFromUrl(afterDecode, 'outerAccountName');
    return { redirectUrl, appId, thirdName, outerAccountId, outerAccountName };
  };
  const onSubmit = () => {
    RPCFactory.third
      .authResult({ ...paras, authStatus: 1 })
      .done((data) => {
        window.location.href = data.redirectUrl;
      })
      .fail((ret, msg) => {
        window.alert(msg);
      });
  };
  const onCancel = () => {
    RPCFactory.third
      .authResult({ ...paras, authStatus: 2 })
      .done((data) => {
        window.location.href = data.redirectUrl;
      })
      .fail((ret, msg) => {
        window.alert(msg);
      });
  };
  const paras = parseURL();
  const [show, setShow] = useState(true);
  const bodyComponent = () => (
    <div className="auth-page-content">
      授权通过后，<p className="third-name">{paras.thirdName}</p>中
      <p className="account-name">{decodeURIComponent(paras.outerAccountName || '')}</p>
      的转化数据将自动同步到腾讯-线索管理平台
    </div>
  );
  return (
    <div className="auth-page">
      <Dialog
        show={show}
        onClose={handleClose}
        onSubmit={onSubmit}
        onCancel={onCancel}
        title="授权后将支持以下内容"
        submitLabel="同意"
        BodyComponent={bodyComponent}
        className="auth-dialog modal-w500"
      >
        授权通过后，樱桃系统中转化数据将自动同步到腾讯-线索管理平台
      </Dialog>
    </div>
  );
};
